<template>
  <div id="Feed">
    <SidbarAdmin
      :setready="s"
      :setmyjob="myjobs"
      :setpacking="packing"
      :orders="newjobs"
    />
    <div class="sapce"></div>
    <b-container class="bv-example-row">
      <b-row>
        <b-col cols="4">
          <b-button v-b-modal.modal-center variant="info" class="float-left"
            >+New Activity
          </b-button>
        </b-col>
        <b-col cols="2"> </b-col>
        <b-col cols="6">
          <input
            id="myInput"
            type="text"
            placeholder="Search.."
            class="form-control shadow"
            pull-right
            style="border-radius: 40px; margin-bottom: 20px"
        /></b-col>
      </b-row>
      <!-- Modal form -->
      <!-- <b-button v-b-modal.modal-center>Launch centered modal</b-button> -->

      <b-modal
        size="lg"
        id="modal-center"
        centered
        header-border-variant="white"
        class="border-bottom-0"
        :hide-footer="true"
      >
        <template #modal-title>
          <div
            class="card card-order-list card-margin shadow border-light"
            style="border-radius: 40px"
          >
            <div class="card-body">
              <img
                src="../../assets/icons/inprogress.gif"
                alt=""
                width="40"
                height="auto"
              />
              <!-- <i class="fa-solid fa-bookmark"></i> -->
              {{ auth.std_name }} กำลังสร้างกิจกรรม
            </div>
          </div>
        </template>
        <div class="card card-order-list card-margin shadow border-light">
          <div class="card-body">
            <form class="form-group">
              <!-- @submit.prevent=" " -->

              <b-row>
                <b-col cols="6">
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder="ชื่อกิจกรรม"
                  />
                </b-col>
                <b-col cols="6">
                  <input
                    type="text"
                    class="form-control input-style"
                    placeholder="ชื่อหัวหน้ากิจกรรม"
                  />
                </b-col>
                <b-col
                  cols="12"
                  v-for="(course, index) in courses"
                  :key="index"
                >
                  <b-row>
                    <b-col cols="12">
                      <!-- <label class="typo__label"></label> -->
                      <!-- <multiselect
                        v-model="value"
                        tag-placeholder="สมาชิก"
                        placeholder="เลือกสมาชิก"
                        label="name"
                        track-by="code"
                        :options="options"
                        :multiple="true"
                        :taggable="true"
                        @tag="addTag"
                      ></multiselect> -->
                      <!-- <pre class="language-json"><code>{{ value  }}</code></pre> -->
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="6">
                  <label for="date-start"></label>
                  <b-form-datepicker
                    hide-header
                    id="date-start"
                    v-model="valueDateStart"
                    class="mb-4 form-control input-style"
                    placeholder="Date Start"
                  ></b-form-datepicker>
                  <!-- <p>Value: '{{ valueDateStart }}'</p> -->
                </b-col>
                <b-col cols="6">
                  <label for="date-end"></label>
                  <b-form-datepicker
                    hide-header
                    id="date-end"
                    v-model="valueDateEnd"
                    placeholder="Date End"
                    class="mb-4 form-control input-style b-between"
                  ></b-form-datepicker>
                  <!-- <p>Value: '{{ valueDateEnd }}'</p> -->
                </b-col>
              </b-row>
              <!-- :disabled="!isComplete" -->
              <button
                type="submit"
                class="btn btn-purple deep-purple btn-block badge-pill"
                data-dismiss="modal"
                @click="showModal = false"
              >
                ยืนยัน
              </button>
            </form>
          </div>
        </div>
      </b-modal>

      <!-- End modal form -->

      <!-- <br /> -->
      <b-table
        striped
        hover
        :items="items"
        :fields="fields"
        responsive="sm"
        :per-page="perPageAll"
        :current-page="currentPageAll"
        @row-clicked="toggleDetails"
        id="my-table"
        head-variant="dark"
        class="text-left shadow"
      >
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
        <template #cell(rating)="data">
          <div class="star-ratings">
            <div class="fill-ratings" :style="{ width: data.item.Rating }">
              <span>★★★★★</span>
            </div>
            <div class="empty-ratings">
              <span>★★★★★</span>
            </div>
          </div>
        </template>
        <template #cell(status)="data">
          <b-button
            variant="outline-info"
            class="b-between"
            pill
            style="bottom: 10px"
            v-b-modal.modalPopover
          >
            ผลการประเมิน
          </b-button>

          <b-button
            variant="outline-primary"
            pill
            style="margin-left: 10px"
            @click="linkToqrcode(data.item.Numberfor)"
          >
            QRCode
          </b-button>
        </template>
      </b-table>
      <b-modal
        id="modalPopover"
        ok-only
        size="xl"
        header-border-variant="white"
        class="border-bottom-0"
        footer-border-variant="white"
          slot="modal-footer"
      >
      <b-table striped hover  :items="items"
        :fields="fields">
        <template #cell(index)="data">
          {{ data.index + 1 }}
        </template>
      </b-table>
      </b-modal>
     
      <!-- <b-modal
          size="lg"
          id="modal-rating"
          centered
          header-border-variant="white"
          class="border-bottom-0"
          header-bg-variant="danger"
          hide-header
          footer-border-variant="white"
          slot="modal-footer"
        >
        <div class="text-center mt-3">
            <img
                              src="../../assets/icons/cancel.gif"
                              alt=""
                              width="50%"
                              height="auto"
                              class="rounded-circle"
                            />
          </div>

        <template #modal-footer="{ ok, cancel }">
            <b-button
              size="lg"
              class="b-between"
              variant="success"
              data-dismiss="modal"
              type="submit"
              @click="ok()"
            >
              OK
            </b-button>

            <b-button
              size="lg"
              class="b-between"
              variant="danger"
              @click="cancel()"
            >
              No
            </b-button> 
        </template>
         </b-modal>  -->

      <!-- <template #row-details="row">
          <div class="container">
            <table class="table table-Light">
              <thead class="table-info">
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">ชื่อ - นามสกุล</th>
                  <th scope="col">ฝ่ายงาน</th>
                  <th scope="col">rating</th>
                </tr>
              </thead>
              <tbody class="text-left">
                <tr v-for="(proc, index) in row.item.members" :key="index">
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ proc.name }}</td>
                  <td>{{ proc.department }}</td>
                  <td>
                    <div class="star-ratings">
                      <div class="fill-ratings" :style="{ width: 50 + '%' }">
                        <span>★★★★★</span>
                      </div>
                      <div class="empty-ratings">
                        <span>★★★★★</span>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template> -->
      <div class="pagination-div">
        <b-pagination
          v-model="currentPageAll"
          :total-rows="rows"
          :per-page="perPageAll"
          aria-controls="my-table"
          pills
          align="right"
        ></b-pagination>
      </div>
    </b-container>
  </div>
</template>

<script>
import SidbarAdmin from "../layouts/sidbar-admin.vue";
import axios from "axios";
import $ from "jquery";
// import Multiselect from "vue-multiselect";
export default {
  components: { SidbarAdmin },
  name: "Feed",
  data() {
    return {
      ready: [],
      token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      readMore: {},
      isLoading: false,
      show: false,
      orderMore: {},
      s: [],
      newjobs: [],
      myjobs: [],
      packing: [],
      code: "",
      transProps: {
        // Transition name
        name: "flip-list",
      },
      items: [],
      fields: [
        { key: "index", label: "No.", sortable: true },
        { key: "Activities", sortable: true },
        { key: "Supervisor" },
        { key: "DateStart", sortable: true },
        { key: "DateEnd", sortable: true },
        { key: "Rating" },
        { key: "Status" },
      ],
      perPageAll: 20,
      currentPageAll: 1,
      valueDateStart: "",
      valueDateEnd: "",
      courses: [
        {
          courseName: "",
        },
      ],

      options: [
        { name: "จุรีพร ศรีธัญรัตน์ ", code: 1 },
        { name: "มะลิวัลย์ แผ่นทอง", code: 2 },
        { name: "อรทัย ทองอินทร์", code: 3 },
        { name: "เพียงกมล บุตรแก้ว", code: 4 },
        { name: "จี ทัศบุตร", code: 5 },
        { name: "กมลพักตร์ โสภา", code: 6 },
        { name: "อธิกา พรพรหม", code: 7 },
        { name: "เอกชัย เจริญราษฎร์", code: 8 },
        { name: "สาริกา แสงสุวรรณ์", code: 9 },
        { name: "ปิยธิดา สิงห์ธรรม", code: 10 },
        { name: "ประกรณ์ อินทพันธ์", code: 11 },
        { name: "ทองเสี่ยน จันทร์พูล", code: 12 },
        { name: "ภาวิณี  ปุราชะนัย", code: 13 },
        { name: "คณิต มณีเนตร", code: 14 },
        { name: "สมพร สุชาตะประคัลภ์", code: 15 },
        { name: "เมธา พิมพะกรรณ์", code: 16 },
        { name: "อนุชิต สินทรัพย์", code: 17 },
        { name: "วิรัตน์ รูปแข็ง", code: 18 },
        { name: "สุมิตย์ อินปาว", code: 19 },
        { name: "หนูเพียร สัตย์ธรรม", code: 20 },
        { name: "วทัญญู หินผา", code: 21 },
      ],
      selected: null,
      value: [
        // { name: 'Javascript', code: 'js' }
      ],
      // options: [
      //   { name: 'Vue.js', code: 'vu' },
      //   { name: 'Javascript', code: 'js' },
      //   { name: 'Open Source', code: 'os' }
      // ]
    };
  },
  mounted() {
    if (localStorage.getItem("auth") != null) {
      this.items = [
        {
          Activities: "14 กุมภา วันราชภัฏ",
          Supervisor: "เพียงกมล บุตรแก้ว",
          DateStart: "2023-02-13",
          DateEnd: "2023-02-17",
          Status: "วันราชภัฏ",
          Rating: "50%",
          Numberfor: "L001",
          members: [
            {
              name: "ภาวิณี  ปุราชะนัย",
              department: "เจ้าหน้าที่บริหารงานทั่วไป",
              rate: "50%",
            },
            {
              name: "เพียงกมล บุตรแก้ว",
              department: "เจ้าหน้าที่บรรณารักษ์",
              rate: "50",
            },
          ],
        },
        {
          Activities: "อบรมระบบ USL (UBRU Smart library)",
          Supervisor: "ทองเสี่ยน จันทร์พูล",
          DateStart: "2023-02-21",
          DateEnd: "2023-02-21",
          Status: "อบรมระบบ USL (UBRU Smart library)",
          Rating: "",
          Numberfor: "L002",
          members: [
            {
              name: "ภาวิณี  ปุราชะนัย",
              department: "เจ้าหน้าที่บริหารงานทั่วไป",
              rate: "50%",
            },
            {
              name: "ภาวิณี  ปุราชะนัย",
              department: "เจ้าหน้าที่บรรณารักษ์",
              rate: "50%",
            },
          ],
        },
      ];
      console.log(this.items);
      this.user = false;
      this.auth = JSON.parse(localStorage.getItem("auth"));
      this.code = this.auth.std_code;
      // console.log(this.auth);
      if (this.auth.user_type === "Teacher" || this.auth.isLibraryStaff === 0) {
        this.isShowstaff;
      } else if (this.auth.user_type === "Student") {
        this.isShowstaff = true;
      }

      if (this.auth.isLibraryStaff === 1) {
        this.staff = true;
      } else {
        this.staff = false;
      }
    } else {
      this.user = true;
      this.isShowstaff = true;
    }
    this.getready();
    $(document).ready(function () {
      $("#myInput").on("keyup", function () {
        var value = $(this).val().toLowerCase();
        $("#my-table tr").filter(function () {
          $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
        });
      });
    });

    $(document).ready(function () {
      // Gets the span width of the filled-ratings span
      // this will be the same for each rating
      var star_rating_width = $(".fill-ratings span").width();
      // Sets the container of the ratings to span width
      // thus the percentages in mobile will never be wrong
      $(".star-ratings").width(star_rating_width);
    });
  },
  methods: {
    addTag(newTag) {
      const tag = {
        name: newTag,
        code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000),
      };
      this.options.push(tag);
      this.value.push(tag);
    },
    getready() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_ready", data, {
          headers,
        })
        .then((res) => {
          this.ready = res.data.Orders;
          this.s = this.ready.length;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          this.$isLoading(false);
        });
    },
    toggleDetails(item) {
      // console.log(item);
      this.detail = item.b4web_id;
      if (item["_showDetails"]) item["_showDetails"] = false;
      else this.$set(item, "_showDetails", true);
    },
    addMore() {
      this.courses.push({
        courseName: "",
      });
    },
    remove(index) {
      this.courses.splice(index, 1);
    },
    linkToqrcode(link) {
      let route = this.$router.resolve({ path: "/qrcode/" + link });
      window.open(route.href);
      // this.$router.push("/qrcode/" + link);
      //   console.log(link);
    },
  },
};
</script>

<style scoped>
.sapce {
  height: 100px;
}
table #table-transition-example.flip-list-move {
  transition: transform 1s;
}

.form-group input {
  margin-bottom: 20px;
}
.form-group button {
  margin-bottom: 20px;
}
.input-style {
  border-radius: 30px;
  background-color: #ffffff;
  border-color: #cecece;
  color: #000000;
}
.add-input-members {
  position: relative;
}
.icon-add-input-members {
  position: absolute;
  margin-left: 250px;
  bottom: -20px;
  color: rgb(79, 159, 0);
  z-index: 999;
}
.add-input-members-control {
  color: rgb(79, 159, 0);
  margin-left: -10px;
}
.add-input-members-minus {
  color: #e50000;
  margin-left: -10px;
}
/* rate */
.star-ratings {
  unicode-bidi: bidi-override;
  color: #ccc;
  font-size: 20px;
  position: relative;
  margin: 0;
  padding: 0;
  font-family: FontAwesome;
}
/*  */
.star-ratings .fill-ratings {
  color: #6e07dd;
  /* #ff7a70; */
  padding: 0;
  position: absolute;
  z-index: 1;
  display: block;
  top: 0;
  left: 0;
  overflow: hidden;
  font-family: FontAwesome;
}
.star-ratings .fill-ratings span {
  display: inline-block;
  font-family: FontAwesome;
}
.star-ratings .empty-ratings {
  padding: 0;
  display: block;
  z-index: 0;
}
/*  */
.multiselect__tags {
  border-radius: 30px !important;
}
</style>
